import { createEntityQueryEndpoints } from './createEntityQueryEndpoints';
import { createEventQueryEndpoints } from './createEventQueryEndpoints';
import { createCustomQueryEndpoints } from './customSubgraphQuery';
export const allSubgraphSliceEndpoints = {
    endpoints: (builder) => ({
        ...createCustomQueryEndpoints(builder),
        ...createEntityQueryEndpoints(builder),
        ...createEventQueryEndpoints(builder),
    }),
};
//# sourceMappingURL=allSubgraphSliceEndpoints.js.map